export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11455.01bba7a6.jpg";